import Vue from "vue";
import VueRouter from "vue-router";
import act from "./act.js";
import login from "./login.js";
import store from "../store";
import Meta from "vue-meta";
import versionTood from "@/assets/js/versionUpdate";
Vue.use(VueRouter);
Vue.use(Meta);

const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  if (location) {
    store.commit("setRouterPath", location);
  }
  return routerPush.call(this, location).catch(error => error);
};

const routes = [...login, ...act];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  routes,
});



const env = process.env.NODE_ENV;
/**
 * @type {string[]}
 */
let noTokenPath;
if (env === 'development' || env === 'local') {
  noTokenPath = ["/indexPageh5", "/login", "/help", "/help/", "/", "/leafLet", "/regist", "/agreement", "/agreementUSD", "/privacyPolicy", "/privacyPolicyUSD", "/disclaimers", "/checkphone", "/accountInfoOpe", "/announcement", "/elementIssue", "/feedbackDetail", "/feedback", "/aritReport", "/PANDAEDI", '/tiktokBC']
} else {
  noTokenPath = ["/indexPageh5", "/login", "/help", "/help/", "/", "/leafLet", "/regist", "/agreement", "/agreementUSD", "/privacyPolicy", "/privacyPolicyUSD", "/disclaimers", "/checkphone", "/accountInfoOpe", "/announcement", "/elementIssue", "/feedbackDetail", "/feedback", "/aritReport", "/PANDAEDI",'/tiktokBC'];
}


// "/defrayedCallback","/payoneerAuthCallback","/accountApplyTikTok"


router.beforeEach((to, from, next) => {
  versionTood.isNewVersion(); //判断当前代码版本是否与服务器中代码版本一致，如不一致则刷新页面获取最新
  if (to.meta.metaInfo) {
    store.commit("CHANGE_META_INFO", to.meta.metaInfo);
  }
  if (noTokenPath.includes(to.path)) {
    next();
  } else {
    const perm_tree = localStorage.getItem("userinfo") ? JSON.parse(localStorage.getItem("userinfo")).perm_tree[0].children : [];
    let canEnter = filterTableMater(to.path, perm_tree);
    if (canEnter) {
      if (canEnter.checked) {
        const token = window.localStorage.getItem("token");
        if (!token) {
          if (from.path === "/coupon") {
            sessionStorage.setItem("couponURL", location.search);
          }
          next("/login");
        } else {
          let userinfo = JSON.parse(localStorage.getItem("userinfo"));
          if (userinfo) {
            store.commit("SET_IS_PREPAID_RECHARGE", userinfo.is_prepaid_recharge);
            store.commit("SET_CREDITBALANCE", userinfo.credit_amount);
          }
          let setCompanyState = JSON.parse(localStorage.getItem("setCompanyState"));
          let setIsPerfect = localStorage.getItem("setIsPerfect");
          store.commit("setCompanyState", setCompanyState);
          store.commit("setIsPerfect", JSON.parse(setIsPerfect)); //企业信息状态
          next();
        }
      } else {
        next("/personalInfo");
      }
    } else {
      if (to.path === "/coupon") {
        sessionStorage.setItem("couponURL", location.search);
      }
      next("/login");
    }
  }
});


/**
 * @description: 递归遍历查找数组对象的某个值
 * @param {string} code
 * @param {array} arr
 * @returns {object}
 */
const filterTableMater = (path, arr) => {
  for (const item of arr) {
    if (item.menu_to === path) {
      return item;
    }
    if (item.children && item.children.length) {
      const _item = filterTableMater(path, item.children);
      if (_item) {
        return _item;
      }
    }
  }
};

export default router;
